// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H7b7H"};